import { render, staticRenderFns } from "./DistribuicaoPedidos.vue?vue&type=template&id=44c6cbca&scoped=true"
import script from "./DistribuicaoPedidos.vue?vue&type=script&lang=js"
export * from "./DistribuicaoPedidos.vue?vue&type=script&lang=js"
import style0 from "./DistribuicaoPedidos.vue?vue&type=style&index=0&id=44c6cbca&prod&scoped=true&lang=css"
import style1 from "./DistribuicaoPedidos.vue?vue&type=style&index=1&id=44c6cbca&prod&scoped=true&lang=css"
import style2 from "./DistribuicaoPedidos.vue?vue&type=style&index=2&id=44c6cbca&prod&scoped=true&lang=css"
import style3 from "./DistribuicaoPedidos.vue?vue&type=style&index=3&id=44c6cbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c6cbca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VAutocomplete,VBtn,VChip,VCol,VDataTable,VIcon,VRow,VTextField})
